import {initializeApp} from 'firebase/app'
import {getAuth, GoogleAuthProvider, EmailAuthProvider} from 'firebase/auth'
import { getFirestore } from 'firebase/firestore';
import { getStorage} from "firebase/storage";
// import firebase from "firebase"

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyClQv2-ykB0iE5dXSPgCjfrtVKx08E8k-E",
    authDomain: "vchat-6da94.firebaseapp.com",
    databaseURL: "https://vchat-6da94-default-rtdb.firebaseio.com",
    projectId: "vchat-6da94",
    storageBucket: "vchat-6da94.appspot.com",
    messagingSenderId: "678620383390",
    appId: "1:678620383390:web:d2a5132e564379b451138f",
    measurementId: "G-XVNH55P9LD"
  };
  
  const app = initializeApp(firebaseConfig)

  export const auth = new getAuth(app)
export const provider = new GoogleAuthProvider();
export const providere = new EmailAuthProvider();
export const db = getFirestore();
export const storage = getStorage();
